import React from "react";

import AuditListItem from '../audit-list-item/audit-list-item.component';

export default function AuditList({ auditList }) {

    return (
        <div className="collapse pl-2 mt-3" id="collapsed-history">
            <ul className="list-unstyled">
                {auditList.map((auditItem, index) => (
                    <AuditListItem key={index} item={auditItem} index={index} />
                ))}
            </ul>
        </div>
    )
}